import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ChatConnectWidget } from "@/components/ChatConnectWidget";
import Index from "./pages/Index";
import UnifiedLogin from "./pages/UnifiedLogin";
import ResetPassword from "./pages/ResetPassword";
import FirstAccess from "./pages/FirstAccess";
import Clients from "./pages/Clients";
import AdminUsers from "./pages/AdminUsers";
import NotFound from "./pages/NotFound";
import Dashboard from "./pages/Dashboard";
import Monitoring from "./pages/Monitoring";
import Campaigns from "./pages/Campaigns";
import ClientTriggers from "./pages/ClientTriggers";
import ClientBusinessRules from "./pages/ClientBusinessRules";
import ClientDisparos from "./pages/ClientDisparos";
import Disparos from "./pages/Disparos";
import DisparoAvulso from "./pages/DisparoAvulso";
import CampanhasIntegradas from "./pages/CampanhasIntegradas";
import QueueMonitoringPage from "./pages/QueueMonitoring";
import ClientSuccess from "./pages/ClientSuccess";
import TemplateMapping from "./pages/TemplateMapping";
import TemplateStrategyDebug from "./components/TemplateStrategyDebug";
import Settings from "./pages/Settings";
import Sales from "./pages/Sales";
import CommercialSettings from "./pages/CommercialSettings";
import Attendances from "./pages/Attendances";
import Schedule from "./pages/Schedule";
import ClientSchedule from "./pages/ClientSchedule";
import CustomerSupport from "./pages/CustomerSupport";
import Tickets from "./pages/Tickets";
import BusinessIntelligence from "./pages/BusinessIntelligence";
import AuditLogs from "./pages/AuditLogs";
import CentralCobranca from "./pages/CentralCobranca";
import BusinessRulesAcceptancePage from "./pages/BusinessRulesAcceptance";
import Email from "./pages/Email";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster />
          <Sonner />
          <ChatConnectWidget />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/login" element={<UnifiedLogin />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/first-access" element={<FirstAccess />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/client-schedule" element={<ClientSchedule />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/users" element={<AdminUsers />} />
            <Route path="/monitoring" element={<Monitoring />} />
            <Route path="/campaigns" element={<Campaigns />} />
            <Route path="/client-triggers" element={<ClientTriggers />} />
            <Route path="/client-business-rules" element={<ClientBusinessRules />} />
            <Route path="/client-disparos" element={<ClientDisparos />} />
            <Route path="/disparos" element={<Disparos />} />
            <Route path="/disparo-avulso" element={<DisparoAvulso />} />
            <Route path="/campanhas-integradas" element={<CampanhasIntegradas />} />
            <Route path="/queues-monitoring" element={<QueueMonitoringPage />} />
            <Route path="/client-success" element={<ClientSuccess />} />
            <Route path="/template-mapping" element={<TemplateMapping />} />
            <Route path="/debug/template-strategies" element={<TemplateStrategyDebug />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/settings/commercial" element={<CommercialSettings />} />
            <Route path="/sales" element={<Sales />} />
            <Route path="/attendances" element={<Attendances />} />
            <Route path="/customer-support" element={<CustomerSupport />} />
            <Route path="/tickets" element={<Tickets />} />
            <Route path="/business-intelligence" element={<BusinessIntelligence />} />
            <Route path="/audit-logs" element={<AuditLogs />} />
            <Route path="/central-cobranca" element={<CentralCobranca />} />
            <Route path="/aceite/:token" element={<BusinessRulesAcceptancePage />} />
            <Route path="/email" element={<Email />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
